import { EnumSentFaxItemType } from "../Models/Faxing/EnumSentFaxItemType";
import { EnumSentFaxStatus } from "../Models/Faxing/EnumSentFaxStatus";

/**
 * Helper class for handling fax-related operations.
 */
class FaxHelper {
    /**
     * Determines if a PIN is required for the given fax item type.
     * @param itemType - The type of the sent fax item.
     */
    public static isPinRequired(itemType: EnumSentFaxItemType): boolean {
        return (
            itemType == EnumSentFaxItemType.Prescription
            || itemType == EnumSentFaxItemType.ConsultationRequest
            || itemType == EnumSentFaxItemType.LabRequest
            || itemType == EnumSentFaxItemType.RadpdfForm
        );
    }

    /**
     * Get the app route to render a preview of the PDF, if applicable.
     * @param sentFaxId - The ID of the sent fax.
     * @param previewUrl - The URL for the preview.
     * @param isPermanentFaxMessagePath - Indicates if the fax is a permanent message.
     * @param withSignature - Indicates if the preview should include a signature.
     */
    public static getPdfPreviewRoute(sentFaxId: number, previewUrl: string, isPermanentFaxMessagePath: boolean, withSignature: boolean): string | null {
        if (isPermanentFaxMessagePath)
            return `api/pdf/fetchPermanentFaxMessageFile/${sentFaxId}/${withSignature}`;

        if (previewUrl)
            return `api/pdf/fetch/${previewUrl}`;

        return null;
    }

    /**
     * Replace sent fax number format.
     * @param faxNumber The fax number to be replaced.
     */
    public static displayFaxNumberFormat(faxNumber: string): string {
        return faxNumber.replace(/(\d{1,3})(\d{3})(\d{3})(\d{4})/, "+$1 ($2) $3-$4");
    }

    /**
     * Determines if the fax has failed.
     * @param sentStatus The status of the sent fax.
     */
    public static isFailedFax(sentStatus: EnumSentFaxStatus): boolean {
        return sentStatus == EnumSentFaxStatus.NotSent
            || sentStatus == EnumSentFaxStatus.Failed
            || sentStatus == EnumSentFaxStatus.Busy
            || sentStatus == EnumSentFaxStatus.NoAnswer
            || sentStatus == EnumSentFaxStatus.NoRemoteFax;
    }
}

export { FaxHelper };
